import React from 'react';

export default function Line() {
  return <div className="bmc-page-line" />;
}
